/**
 * Returns a function that as long as it continues to be invoked, won't be triggered.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Delay (in milliseconds).
 * @returns {Function}
 */
function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.menu = document.querySelector('.main-menu__content');
      this.sliderMediaQuery = window.matchMedia('(max-width: 860px)');
      this.swiper = null;
      this.isPaused = false;

      this.bindEvents();
      this.init();
    }

    disconnectedCallback() {
      if (this.moveLinksHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLinksHandler);
      }

      if (this.moveLocalizationHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }

      if (this.sliderMediaHandler) {
        this.sliderMediaQuery.removeEventListener('change', this.sliderMediaHandler);
      }

      this.destroyMobileSlider();
    }

    bindEvents() {
      if (this.links.length) {
        this.moveLinksHandler = this.moveLinksHandler || this.moveLinks.bind(this);
        window.addEventListener('on:breakpoint-change', this.moveLinksHandler);
      }

      if (this.slider) {
        this.sliderMediaHandler = this.sliderMediaHandler || this.initMobileSlider.bind(this);
        this.sliderMediaQuery.addEventListener('change', this.sliderMediaHandler);
      }
    }

    /**
     * Start mobile slider if needed.
     */
    init() {
      this.initMobileSlider();

      if (this.links.length) {
        this.moveLinks();
      }

    }

    initMobileSlider() {
      if (!this.slider) return;

      if (!this.sliderMediaQuery.matches) {
        this.destroyMobileSlider();
        return;
      }

      const slides = this.slider.querySelectorAll('.announcement__text');
      this.classList.toggle('announcement--single-slide', slides.length <= 1);
      if (slides.length <= 1) return;

      if (this.swiper) return;

      if (typeof Swiper === 'undefined') {
        if (typeof window.tpgWhenSwiperReady === 'function') {
          window.tpgWhenSwiperReady(() => this.initMobileSlider());
        }
        return;
      }

      this.swiper = new Swiper(this.slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        navigation: {
          nextEl: this.querySelector('.announcement__slider-nav--next'),
          prevEl: this.querySelector('.announcement__slider-nav--prev')
        }
      });
    }

    destroyMobileSlider() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    /**
     * Move the help links selectors to the mobile nav/back to the announcement bar if necessary
     */
    moveLinks() {
      const menuAnnouncementLinks = document.querySelector('.mob__announcement-links');
      if (!theme.mediaMatches.md && !menuAnnouncementLinks) {
        // Move localization to mobile
        const mobNav = document.createElement('nav');
        mobNav.classList.add('mob__announcement-links');

        const mobNavUl = document.createElement('ul');
        mobNav.classList.add('secondary-nav');

        this.links.forEach((link) => {
          mobNav.innerHTML += `<li><a class="secondary-nav__item" href="${link.href}">${link.innerText}</a>`;
        });

        mobNav.appendChild(mobNavUl);
        this.menu.appendChild(mobNav);
      } else if (theme.mediaMatches.md && menuAnnouncementLinks) {
        menuAnnouncementLinks.remove();
      }
    }

    /**
     * Move the localization selectors to the mobile nav/back to the announcement bar if necessary
     */
    moveLocalization() {
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.menu = document.querySelector('.main-menu__content');
      const menuLocalization = document.querySelector('.mob__localization');
      if (!theme.mediaMatches.md && !menuLocalization) {
        // Move localization to mobile
        const mobLocalizationElem = document.createElement('div');
        mobLocalizationElem.classList.add('mob__localization');
        mobLocalizationElem.appendChild(this.localization.firstElementChild);
        this.menu.appendChild(mobLocalizationElem);
      } else if (theme.mediaMatches.md && menuLocalization) {
        // Move localization back to announcement bar
        this.localization.appendChild(menuLocalization.firstElementChild);
        menuLocalization.remove();
      }
    }

    /**
     * Pauses the auto-rotating slider
     */
    pauseSlider() {
      this.isPaused = true;
    }

    /**
     * Resumes the auto-rotating slider
     */
    resumeSlider() {
      this.isPaused = false;
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
